export default __webpack_public_path__ + "static/media/2.30f7a35d.png";